<template lang='pug'>
  div
    v-toolbar(dense)
      v-tooltip(right v-if='selected.length')
        template(v-slot:activator='{on}')
          v-btn(v-on='on' @click='deleteSelected()' text icon color='error')
            v-icon delete
        span Delete
      v-spacer
      v-spacer
      v-text-field#transientsSearch(v-model='search' ref='search' placeholder='Search ("/" to focus)' hide-details prepend-inner-icon='search' clearable single-line)
    table-list(:headers='headers'
      item-key='key'
      v-model='selected'
      :items='transients'
      :total='total'
      :loading='loading'
      @update='update')
      template(v-slot:row='{item, index}')
        td
          router-link(:to='`transients/${item._id}`') {{item.key}}
        td {{item.account.name}}
        td
          time-ago(:date='item.createdAt')
        td
          time-ago(:date='item.updatedAt')
        td
          time-ago(:date='item.expireAt')
        td {{getSelectDataItems(item.data)}}
        td.text-right
          v-menu(offset-y @click.native.stop='' left).mr-3
            template(v-slot:activator='{on}')
              v-btn(text icon v-on='on')
                v-icon more_vert
            v-list
              v-list-item(@click='deleteTransient(item)')
                v-list-item-title Delete
      template(v-slot:item='{item}')
        v-row(no-gutters)
          v-col(cols='12').text-body-1.pa-3
            .text-subtitle-1 {{item.name}}
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') _id:
              v-col
                router-link(:to='`transients/${item._id}`') {{item._id}}
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Key:
              v-col
                router-link(:to='`transients/${item._id}`') {{item.key}}
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Account:
              v-col {{item.account.name}}
                span(v-if='item.accountAdmin') &nbsp;(admin)
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Created:
              v-col
                time-ago-reverse(:date='item.createdAt')
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Updated:
              v-col
                time-ago-reverse(:date='item.updatedAt')
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Expires:
              v-col
                time-ago-reverse(:date='item.expireAt')
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Data:
              v-col {{getSelectDataItems(item.data)}}
            v-row(justify='end')
              v-menu(offset-y @click.native.stop='' left).mr-3
                template(v-slot:activator='{on}')
                  v-btn(text icon v-on='on')
                    v-icon more_vert
                v-list
                  v-list-item(@click='deleteTransient(item)')
                    v-list-item-title Delete
        v-divider
</template>

<script>
import {pick, debounce} from 'lodash';
import SuperAdmin from '@/api/superAdmin';
import Notifications from '@/services/notification.service';
import TableList from '@/components/TableList';
import TableMixin from '@/mixins/table.mixin';
import FocusMixin from '@/mixins/focus.mixin';
import TimeAgo from '@/components/TimeAgo';
import TimeAgoReverse from '@/components/TimeAgoReverse';

export default {
  name: 'SuperAdminTransients',
  components: {TimeAgoReverse, TimeAgo, TableList},
  mixins: [TableMixin, FocusMixin],
  methods: {
    async update(options) {
      this.limit = options.itemsPerPage;
      this.skip = options.itemsPerPage * (options.page - 1);
      this.sort = this.getSortFromOptions(options);
      return this.load();
    },
    async load() {
      this.loading = true;
      const {list, total} = (await SuperAdmin.getTransients({
        skip: this.skip,
        limit: this.limit,
        sort: this.sort,
        search: this.search
      }));
      this.transients = list;
      this.total = total;
      this.loading = false;
    },
    to(route) {
      this.$router.push(route);
    },
    getSelectDataItems(data) {
      return pick(data, ['sender', 'subject']);
    },
    removeTransient(transient) {
      const i = this.transients.findIndex((ts) => ts._id === transient._id);
      this.transients.splice(i, 1);
    },
    async deleteTransient(transient) {
      if (!(await Notifications.confirm('Delete', `Are you sure you want to delete <strong>${transient.key}</strong>?`))) return;
      await SuperAdmin.deleteTransient(transient._id);
      this.removeTransient(transient);
      Notifications.toast('Deleted');
    },
    async deleteSelected() {
      if (!(await Notifications.confirm('Delete', `Are you sure you want to delete <strong>${this.selected.length}</strong> transients?`))) return;
      const all = [];
      for (const transient of this.selected) {
        all.push(SuperAdmin.deleteTransient(transient._id));
        this.removeTransient(transient);
      }
      await Promise.all(all);
      this.selected = [];
      Notifications.toast('Deleted');
    }
  },
  watch: {
    // eslint-disable-next-line
    search: debounce(function () {
      this.load();
    }, 250)
  },
  data() {
    return {
      selected: [],
      transients: [],
      transient: {},
      search: '',
      total: 0,
      loading: false,
      skip: 0,
      limit: 10,
      sort: null,
      defaultSort: {updatedAt: -1},
      headers: [
        {text: 'Key', value: 'key'},
        {text: 'Account', value: 'account'},
        {text: 'Created', value: 'createdAt'},
        {text: 'Updated', value: 'updatedAt'},
        {text: 'Expires', value: 'expireAt'},
        {text: 'Data', value: 'data', sortable: false},
        {text: '', value: 'actions', sortable: false}
      ]
    };
  }
};
</script>

<style lang="scss" scoped>

</style>
